  <template>
    <h2>Programme du 22-24 mai 2026</h2>
    <div v-if="promoInfos" class="promo" :class="promoInfos.expired ? 'expired' : ''">
      <div class="expired-message" v-if="promoInfos.expired">
        <p>Code promo expiré</p>
      </div>
      <div class="promo-code" v-else>
        <p>-{{ Number(promoInfos.amount).toFixed(0) }}€ pour le programme complet</p>
        <p>Temps restant : {{ promoInfos.timeLeft }}</p>
      </div>
    </div>
    <div v-if="formData.tarifs=='earlybird'" class="promo">
      <div class="promo-code">
        <p>Accès tarif earlybird</p>
        <p>Le prix sera automatiquement mis à jour après les 40 premières inscriptions</p>
      </div>
    </div>
    <div class="events">
      <div v-for="(event, index) in events" :key="index" class="event" :class="checkLockedEvents(event) + ' ' +(formData.selectedEvents.includes(index) ? 'selected' : '')">
        <label>
          <input type="checkbox" :value="index" v-model="formData.selectedEvents" @change="changeDatas(index)" :disabled="checkLockedEvents(event) === 'locked'">
          <span class="name">{{ event.name }}</span>
          <span class="price" :class="formData.tarifs">
            <!-- <span v-if="formData.tarifs=='ath'" class="ath"><i>Ath Pays Vert</i> <strong>{{ index=="brunch"? priceBrunch() : event.ath }}€</strong></span> -->
            <!-- <span v-if="formData.tarifs!='ath'" class="earlybird"><i>Earlybird</i> <strong>{{ event.earlybird }}€</strong></span> -->
            <span class="regular"><i>prix</i> <strong>{{ event.regular }}€</strong></span>
            <span class="late"><i>À partir du 21 mars</i> <strong>{{ event.late }}€</strong></span>
          </span>
        </label>
      </div>
    </div>
    <div class="actions">
      <router-link v-if="formData.selectedEvents.length" class="nextstep" to="/coordonnees">Étape suivante</router-link>
      <button v-else class="nextstep freeze">Étape suivante</button>
    </div>
  </template>
  
  <script>

  export default {
    props: {
      formData: {
        type: Object,
        required: true
      },
      events: {
        type: Object,
        required: true
      },
      promoInfos: {
        type: Object,
        required: true
      },
      updateDatasUser: {
        type: Function,
        required: true
      }
    },
    data() {
      return {};
    },
    methods: {
      changeDatas(event) {
        if (this.events[event].lock.length > 0) {
          this.formData.selectedEvents = this.formData.selectedEvents.filter(selectedEvent => !this.events[event].lock.includes(selectedEvent));
        }
        this.updateDatasUser(this.formData);
      },
      checkLockedEvents(event) {
        if (this.formData.selectedEvents.some(selectedEvent => event.lock.includes(selectedEvent)) || event.lock.includes("")) {
          return 'locked';
        }
        return '';
      },
      priceBrunch() {
        console.log(this.formData.selectedEvents)
        if (this.formData.selectedEvents.includes("complet") || this.formData.selectedEvents.includes("samedicomplet")){
          return 0;
        }else{
          return 20
        }
      }
    }
  };
  </script>
  
  <style scoped>
    .promo{
      align-items: center;
      padding: 2px 20px;
      background-color: #F2B705;
      border-radius: 5px;
      margin-bottom: 10px;
      font-size: 16px;
      font-weight: 600;
      padding: 10px;
      color: white;
      text-align: center;
      
      p{
        margin: 5px 0;
      }
    } 
    .events{
      display: flex;
      flex-direction: column;
      gap: 10px;
      text-align: center;

      .event{
        position: relative;
        overflow: hidden;

        input{
          opacity: 0;
          position: absolute;
          left: -500px;
          top: 0;
        }
        label{
          display: block;
          cursor: pointer;
          border: 1px solid #c1c1c1;
          border-radius: 5px;
          padding: 10px;
          transition: 0.3s ease-in-out;

          .price{
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 13px;
            font-weight: 600;
            margin-top: 10px;
            font-size: 20px;

            span{
              width: 33%;
            }
            i{
              display: block;
              font-size: 12px;
              text-decoration: none !important;
            }
            .ath{
              /* display: none; */
              opacity: 0.4;
              font-size: 14px;
              strong{
                font-weight: 400;
                text-decoration: line-through;
              }
            }
            .earlybird{
              /* display: none; */
              opacity: 0.4;
              font-size: 14px;
              strong{
                font-weight: 400;
                text-decoration: line-through;
              }
            }
            .regular{
              opacity: 0.4;
              font-size: 14px;
              strong{
                font-weight: 400;
                text-decoration: line-through;
              }
            }
            .late{
              opacity: 0.4;
              font-size: 16px;
              strong{
                font-weight: 400;
                text-decoration: line-through;
              }
            }
            &.ath{
              .ath{
                opacity: 1;
                color: #F2B705;
                font-size: 20px;
                strong{
                  font-weight: 600;
                  text-decoration: none;
                }
              }
            }
            &.late{
              .late{
                opacity: 1;
                color: #F2B705;
                font-size: 20px;
                strong{
                  font-weight: 600;
                  text-decoration: none;
                }
              }
            }
            &.regular{
              .regular{
                opacity: 1;
                color: #F2B705;
                font-size: 20px;
                strong{
                  font-weight: 600;
                  text-decoration: none;
                }
              }
            }
            &.earlybird{
              .earlybird{
                opacity: 1;
                color: #F2B705;
                font-size: 20px;

                strong{
                  font-weight: 600;
                  text-decoration: none !important;
                }
              }
            }
          }
        }
        &.selected label{
          background: #167eab;
          border-color: #167eab;
          color: white;

          &:hover{
            background: #167eab;
          }
        }
        &.locked{
          pointer-events: none;
          cursor: not-allowed;
        }
        &.locked label{
          opacity: 0.3;
          cursor: not-allowed;
        }
      }
    }
  </style>